<template>
  <signup-form></signup-form>
</template>

<script>
import SignupForm from '../components/SignupForm.vue'

export default {  
  components: { 
    SignupForm   
  }  
}
</script>